<template>
	<div class="row race-results pane-race-results">
		<div class="small-12 columns">
			<span class="float-right serif winning-time text-right show-for-large" v-if="race.winning_time">
				Winning Time: <strong>{{ race.winning_time }}</strong>
			</span>
			<ul class="inline separated serif">
				<li v-if="race.purse">Purse: <strong>{{ race.purse | currency }}</strong></li>
				<li v-if="race.distance">Distance: <strong>{{ race.distance }}</strong></li>
				<li v-if="race.age_restriction">Age: <strong>{{ race.age_restriction }}</strong></li>
				<li v-if="race.surface" class="not-last-for-large">Surface: <strong>{{ race.surface }}</strong></li>
				<li class="hide-for-large" v-if="race.winning_time">Winning Time: <strong>{{ race.winning_time }}</strong></li>
			</ul>
		</div>
		<div class="small-12 large-6 columns small-order-2 large-order-1 race-results">
			<div class="black-header thin">
				<div class="row">
					<div class="small-6 columns inactive">Results</div>
					<div class="small-2 columns text-right inactive">Win</div>
					<div class="small-2 columns text-right inactive">Place</div>
					<div class="small-2 columns text-right inactive">Show</div>
				</div>
			</div>
			<div class="results-container">
				<result :result="result" v-for="result in starts"></result>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="small-12 columns">
			<a :href="race.url" class="expanded button">More Detail</a>
		</div>
	</div>
</template>

<script>
	import Result from './Result.vue'
	import _ from 'underscore';
	export default {
		components: { Result },
		props: [ 'race' ],
		data () {
			return {
				id: Foundation.GetYoDigits(10, 'abr-rcn')
			}
		},
		computed: {
			placeholder () {
				return window.Drupal.settings.abr_general.placeholder_image;
			},
			starts () {
				return _.sortBy(this.race.start, 'finish_position');
			}
		},
		asyncData () {
			return this.race.loadRelationship('start').then(function () {
				return {};
			});
		}
	}
</script>



/** WEBPACK FOOTER **
 ** RaceResults.vue?6a8b2d75
 **/